export class GeoJson {
    type: string;
    geometry? : {
        type: string;
        coordinates:Number[];
    };
    features?: GeoJson[];
    properties?:Object;
}